"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TerrainTypes_1 = require("../TerrainTypes");
var math_1 = require("../tools/math");
function generateTrees(map, chance) {
    for (var x = 0; x < map.width; x++) {
        for (var y = 0; y < map.height; y++) {
            // can only plant tree on soil
            if (map.getAt(x, y).terrain === TerrainTypes_1.TerrainTypes.Earth) {
                if (math_1.evaluateChance(chance)) {
                    map.safeWrite(x, y, TerrainTypes_1.TerrainTypes.Tree);
                }
            }
        }
    }
}
exports.generateTrees = generateTrees;
